import "react-medium-image-zoom/dist/styles.css";
import { CrewSettings } from "./CrewSettings";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { ContainerWithHeaderAndMenu } from "../menuandheader/ContainerWithHeaderAndMenu";
import { useTranslation } from "react-i18next";

export function ManageCrews() {
  const { t } = useTranslation();

  return (
    <ContainerWithHeaderAndMenu icon={faUsers} title={t("menu.manageCrews")}>
      <p>{t("crew.manage.desc1")}</p>
      <p>{t("crew.manage.desc2")}</p>

      <CrewSettings />
    </ContainerWithHeaderAndMenu>
  );
}
